module.exports = __webpack_public_path__ + "static/MyBlog-e9bc31fa1948c7550b4ef1e1e4e07e4c.png";